angular
    .module("skillBuilderSaaS")
    .directive("vertilizeContainer", [function () {
        return {
            restrict: "EA",
            controller: ["$scope", "$window", function ($scope, $window) {
                    // Alias this
                    var vm = this;
                    // Array of children heights
                    vm.childrenHeights = [];
                    // API: Allocate child, return index for tracking.
                    vm.allocateMe = function () {
                        vm.childrenHeights.push(0);
                        return (vm.childrenHeights.length - 1);
                    };
                    // API: Update a child's height
                    vm.updateMyHeight = function (index, height) {
                        vm.childrenHeights[index] = height;
                    };
                    // API: Get tallest height
                    vm.getTallestHeight = function () {
                        var height = 0;
                        for (var i = 0; i < vm.childrenHeights.length; i = i + 1) {
                            height = Math.max(height, vm.childrenHeights[i]);
                        }
                        return height;
                    };
                    // Add window resize to digest cycle
                    angular.element($window).bind("resize", function () {
                        return $scope.$apply();
                    });
                }]
        };
    }]);
